import Vue from "vue";
import VueRouter from "vue-router";
import VueMeta from "vue-meta";

Vue.use(VueRouter);
Vue.use(VueMeta);

//setup
const SetupServersPage = () => import(/* webpackChunkName: "group-setup" */ "./pages/SetupServersPage.vue");
const SetupServersIndexPage = () =>
    import(/* webpackChunkName: "group-setup" */ "./pages/setup/SetupServersIndexPage.vue");
const SetupServersAddSystemPage = () =>
    import(/* webpackChunkName: "group-setup" */ "./pages/setup/SetupServersAddSystemPage.vue");
const AddDOConnectorPage = () =>
    import(/* webpackChunkName: "group-setup" */ "./pages/setup/connectors/AddDOConnectorPage.vue");
const AddDOConnectorReplyPage = () =>
    import(/* webpackChunkName: "group-setup" */ "./pages/setup/connectors/AddDOConnectorReplyPage.vue");
const AddSystemIndex = () => import(/* webpackChunkName: "group-setup" */ "./components/setup/AddSystemIndex.vue");
const AddDOServer = () =>
    import(/* webpackChunkName: "group-setup" */ "./components/setup/connectors/digitalocean/AddDOServer.vue");
const AddDOConnectorDefault = () =>
    import(
        /* webpackChunkName: "group-setup" */ "./components/setup/connectors/digitalocean/AddDOConnectorDefault.vue"
    );
const AddDOConnectorToken = () =>
    import(/* webpackChunkName: "group-setup" */ "./components/setup/connectors/digitalocean/AddDOConnectorToken.vue");
const AddDOConnectorOauth = () =>
    import(/* webpackChunkName: "group-setup" */ "./components/setup/connectors/digitalocean/AddDOConnectorOauth.vue");
const AddDOConnectorOauthReply = () =>
    import(
        /* webpackChunkName: "group-setup" */ "./components/setup/connectors/digitalocean/AddDOConnectorOauthReply.vue"
    );

// main login
import LogoutPage from "./pages/LogoutPage.vue";
import LogoutAsUserPage from "./pages/LogoutAsUserPage.vue";
import LoginAsSupportPage from "./pages/LogInAsSupportPage.vue";
import LoginPage from "./pages/LoginPage.vue";
import LoginMain from "./components/user_login/LoginMain.vue";
import LoginForce2FA from "./components/user_login/LoginForce2FA.vue";
import ForgotPassPage from "./pages/ForgotPassPage.vue";
import ForgotPassMain from "./components/user_login/ForgotPassMain.vue";
import ResetPassPage from "./pages/ResetPassPage.vue";
import ResetPassMain from "./components/user_login/ResetPassMain.vue";
import InviteAccountPage from "./pages/InviteAccountPage.vue";
import InviteAccountMain from "./components/user_login/InviteAccountMain.vue";

// account management
const AccountPage = () => import(/* webpackChunkName: "group-account" */ "./pages/AccountPage.vue");
const AccountPageIndex = () =>
    import(/* webpackChunkName: "group-account" */ "./components/account/AccountPageIndex.vue");
const AccountInformation = () =>
    import(/* webpackChunkName: "group-account" */ "./components/account/AccountInformation.vue");
const Account2FA = () => import(/* webpackChunkName: "group-account" */ "./components/account/Account2FA.vue");
const AccountDisable2FA = () =>
    import(/* webpackChunkName: "group-account" */ "./components/account/AccountDisable2FA.vue");
const AccountSetup2FA = () =>
    import(/* webpackChunkName: "group-account" */ "./components/account/AccountSetup2FA.vue");
const AccountChangePassword = () =>
    import(/* webpackChunkName: "group-account" */ "./components/account/AccountChangePassword.vue");
const AccountNotifications = () =>
    import(/* webpackChunkName: "group-account" */ "./components/account/AccountNotifications.vue");
const AccountApiKeys = () => import(/* webpackChunkName: "group-account" */ "./components/account/AccountApiKeys.vue");
const AccountServerAccounts = () =>
    import(/* webpackChunkName: "group-account" */ "./components/account/AccountServerAccounts.vue");
const AccountSshKeys = () => import(/* webpackChunkName: "group-account" */ "./components/account/AccountSshKeys.vue");
const AccountSubAccounts = () =>
    import(/* webpackChunkName: "group-account" */ "./components/account/AccountSubAccounts.vue");
const AccountEditSubAccount = () =>
    import(/* webpackChunkName: "group-account" */ "./components/account/AccountEditSubAccount.vue");

//servers
const ServersPage = () => import(/* webpackChunkName: "group-servers" */ "./pages/ServersPage.vue");
const ServersIndexPage = () => import(/* webpackChunkName: "group-servers" */ "./pages/servers/ServersIndexPage.vue");
const ServersSetupPage = () => import(/* webpackChunkName: "group-servers" */ "./pages/servers/ServersSetupPage.vue");
const ServersCheckPage = () => import(/* webpackChunkName: "group-servers" */ "./pages/servers/ServersCheckPage.vue");
const ServersAddServerPage = () =>
    import(/* webpackChunkName: "group-servers" */ "./pages/servers/ServersAddServerPage.vue");
const ServersAddClusterPage = () =>
    import(/* webpackChunkName: "group-servers" */ "./pages/servers/ServersAddClusterPage.vue");
const ServersServicesPage = () =>
    import(/* webpackChunkName: "group-servers" */ "./pages/servers/ServersServicesPage.vue");
const ServersFirewallPage = () =>
    import(/* webpackChunkName: "group-servers" */ "./pages/servers/ServersFirewallPage.vue");
const ServersMailSettingsPage = () =>
    import(/* webpackChunkName: "group-servers" */ "./pages/servers/mail/ServersMailSettingsPage.vue");
const ServersMailPage = () =>
    import(/* webpackChunkName: "group-servers" */ "./pages/servers/mail/ServersMailPage.vue");
const ServersMailSslPage = () =>
    import(/* webpackChunkName: "group-servers" */ "./pages/servers/mail/ssl/ServersMailSslPage.vue");
const ServersMailSslIndexPage = () =>
    import(/* webpackChunkName: "group-servers" */ "./pages/servers/mail/ssl/ServersMailSslIndexPage.vue");
const ServersMailSslSelfSignedPage = () =>
    import(/* webpackChunkName: "group-servers" */ "./pages/servers/mail/ssl/ServersMailSslSelfSignedPage.vue");
const ServersMailSslLetsEncryptPage = () =>
    import(/* webpackChunkName: "group-servers" */ "./pages/servers/mail/ssl/ServersMailSslLetsEncryptPage.vue");
const ServersMailSslGenerateCsrPage = () =>
    import(/* webpackChunkName: "group-servers" */ "./pages/servers/mail/ssl/ServersMailSslGenerateCsrPage.vue");
const ServersMailSslCertificatePage = () =>
    import(/* webpackChunkName: "group-servers" */ "./pages/servers/mail/ssl/ServersMailSslCertificatePage.vue");
const ServersFail2BanSettingsPage = () =>
    import(/* webpackChunkName: "group-servers" */ "./pages/servers/ServersFail2BanSettingsPage.vue");

//system restart
import AccountSystemRestart from "./pages/AccountSystemRestart.vue";

//domains
const DomainsPage = () => import(/* webpackChunkName: "group-domains" */ "./pages/DomainsPage.vue");
const DomainsManagePage = () => import(/* webpackChunkName: "group-domains" */ "./pages/domains/manage/DomainsManagePage.vue");
const DomainsSSHKeysPage = () =>
    import(/* webpackChunkName: "group-domains" */ "./pages/domains/DomainsSSHKeysPage.vue");
const DomainsIndexPage = () => import(/* webpackChunkName: "group-domains" */ "./pages/domains/DomainsIndexPage.vue");
const DomainsImportCpanelPage = () =>
    import(/* webpackChunkName: "group-domains-import" */ "./pages/domains/DomainsImportCpanelPage.vue");
const DomainsImportClusterCSPage = () =>
    import(/* webpackChunkName: "group-domains-import */ "./pages/domains/DomainsImportClusterCSPage.vue");

// manage
const DomainsManageIndexPage = () =>
    import(/* webpackChunkName: "group-domains-manage" */ "./pages/domains/manage/ManageIndexPage.vue");
const DomainsManageCreatePage = () =>
    import(/* webpackChunkName: "group-domains-manage" */ "./pages/domains/manage/ManageCreatePage.vue");
const DomainsManageEditPage = () =>
    import(/* webpackChunkName: "group-domains-manage" */ "./pages/domains/manage/ManageEditPage.vue");
const DomainsManageEditEnvPage = () =>
    import(/* webpackChunkName: "group-domains-manage" */ "./pages/domains/manage/ManageEditEnvPage.vue");

//environments
const EnvironmentsPage = () =>
    import(/* webpackChunkName: "group-domains-environments */ "./pages/EnvironmentsPage.vue");
const DomainsEnvironmentsManagePage = () =>
    import(
        /* webpackChunkName: "group-domains-environments */ "./pages/domains/environments/DomainsEnvironmentsManagePage.vue"
    );
const DomainsEnvironmentsGitBranchSettingsPage = () =>
    import(/* webpackChunkName: "group-domains-environments */ "./pages/domains/environments/GitBranchSettings.vue");
const DomainsEnvironmentsInstallersPage = () =>
    import(
        /* webpackChunkName: "group-domains-environments */ "./pages/domains/environments/installers/InstallersPage.vue"
    );
const DomainsEnvironmentsInstallerPage = () =>
    import(
        /* webpackChunkName: "group-domains-environments */ "./pages/domains/environments/installers/InstallerPage.vue"
    );
const DomainsEnvironmentsSettings = () =>
    import(/* webpackChunkName: "group-domains-environments */ "./pages/domains/environments/Settings.vue");
const DomainsEnvironmentsTrackedItems = () =>
    import(/* webpackChunkName: "group-domains-environments */ "./pages/domains/environments/TrackedItems.vue");
const DomainsEnvironmentsPush = () =>
    import(/* webpackChunkName: "group-domains-environments */ "./pages/domains/environments/Push.vue");
const DomainsEnvironmentsMigrate = () =>
    import(/* webpackChunkName: "group-domains-environments */ "./pages/domains/environments/Migrate.vue");
const DomainsEnvironmentsGitOps = () =>
    import(/* webpackChunkName: "group-domains-environments */ "./pages/domains/environments/GitOps.vue");

//mails
const DomainsMailsPage = () =>
    import(/* webpackChunkName: "group-domains-mail" */ "./pages/domains/mails/DomainsMailsPage.vue");
const DomainsMailsIndexPage = () =>
    import(/* webpackChunkName: "group-domains-mail" */ "./pages/domains/mails/MailIndexPage.vue");
const DomainsMailsCreatePage = () =>
    import(/* webpackChunkName: "group-domains-mail" */ "./pages/domains/mails/MailCreatePage.vue");
const DomainsMailsManagePage = () =>
    import(/* webpackChunkName: "group-domains-mail" */ "./pages/domains/mails/MailManagePage.vue");

//dns
const DomainsDnsPage = () =>
    import(/* webpackChunkName: "group-domains-mail" */ "./pages/domains/dns/DomainsDnsPage.vue");
const DomainsDnsIndexPage = () =>
    import(/* webpackChunkName: "group-domains-mail" */ "./pages/domains/dns/DnsIndexPage.vue");

//backups
const DomainsBackupsPage = () =>
    import(/* webpackChunkName: "group-domains-backups" */ "./pages/domains/backups/DomainsBackupsPage.vue");
const DomainsBackupsIndexPage = () =>
    import(/* webpackChunkName: "group-domains-backups" */ "./pages/domains/backups/BackupsIndexPage.vue");
const DomainsBackupCreateRepoPage = () =>
    import(/* webpackChunkName: "group-domains-backups" */ "./pages/domains/backups/RepoCreatePage.vue");
const DomainsBackupEditRepoPage = () =>
    import(/* webpackChunkName: "group-domains-backups" */ "./pages/domains/backups/RepoEditPage.vue");
const DomainsBackupCreateJobPage = () =>
    import(/* webpackChunkName: "group-domains-backups" */ "./pages/domains/backups/BackupJobCreatePage.vue");
const DomainsBackupEditJobPage = () =>
    import(/* webpackChunkName: "group-domains-backups" */ "./pages/domains/backups/BackupJobEditPage.vue");
//ssl
const DomainsSslPage = () =>
    import(/* webpackChunkName: "group-domains-ssl" */ "./pages/domains/ssl/DomainsSslPage.vue");
const DomainsSslIndexPage = () =>
    import(/* webpackChunkName: "group-domains-ssl" */ "./pages/domains/ssl/SslIndexPage.vue");
const DomainsSslSelfSignedPage = () =>
    import(/* webpackChunkName: "group-domains-ssl" */ "./pages/domains/ssl/SslSelfSignedPage.vue");
const DomainsSslLetsEncryptPage = () =>
    import(/* webpackChunkName: "group-domains-ssl" */ "./pages/domains/ssl/SslLetsEncryptPage.vue");
const DomainsSslGenerateCsrPage = () =>
    import(/* webpackChunkName: "group-domains-ssl" */ "./pages/domains/ssl/SslGenerateCsrPage.vue");
const DomainsSslCertificatePage = () =>
    import(/* webpackChunkName: "group-domains-ssl" */ "./pages/domains/ssl/SslCertificatePage.vue");

//logs
const DomainsLogsPage = () =>
    import(/* webpackChunkName: "group-domains-mail" */ "./pages/domains/logs/DomainsLogsPage.vue");

//cronjobs
const DomainsCronjobsPage = () =>
    import(/* webpackChunkName: "group-domains-cronjobs" */ "./pages/domains/cronjobs/DomainCronjobsPage.vue");
const DomainsCronjobsIndexPage = () =>
    import(/* webpackChunkName: "group-domains-cronjobs" */ "./pages/domains/cronjobs/CronjobsIndexPage.vue");
const DomainsCronjobsCreatePage = () =>
    import(/* webpackChunkName: "group-domains-cronjobs" */ "./pages/domains/cronjobs/CronjobsCreatePage.vue");
const DomainsCronjobsManagePage = () =>
    import(/* webpackChunkName: "group-domains-cronjobs" */ "./pages/domains/cronjobs/CronjobsManagePage.vue");

//ftp
// const DomainsFtpPage = () =>
//     import(/* webpackChunkName: "group-domains-ftp" */ "./pages/domains/ftp/DomainsFtpPage.vue");
// const DomainsFtpIndexPage = () =>
//     import(/* webpackChunkName: "group-domains-ftp" */ "./pages/domains/ftp/DomainsFtpIndexPage.vue");

//reseller
const ResellerIndexPage = () => import(/* webpackChunkName: "group-domains-mail" */ "./pages/ResellerIndexPage.vue");
const ResellerInfoPage = () =>
    import(/* webpackChunkName: "group-domains-mail" */ "./pages/reseller/ResellerInfoPage.vue");

const ResellerAccountsPage = () =>
    import(/* webpackChunkName: "group-domains-reseller" */ "./pages/reseller/ResellerAccountsPage.vue");
const ResellerAccountsIndex = () =>
    import(/* webpackChunkName: "group-domains-reseller" */ "./components/reseller/ResellerAccountsIndex.vue");
const ResellerEditAccount = () =>
    import(/* webpackChunkName: "group-domains-reseller" */ "./components/reseller/ResellerEditAccount.vue");
const ResellerDeleteAccounts = () =>
    import(/* webpackChunkName: "group-domains-reseller" */ "./components/reseller/ResellerDeleteAccounts.vue");

const ResellerServerPackagesPage = () =>
    import(/* webpackChunkName: "group-domains-reseller" */ "./pages/reseller/ResellerServerPackagesPage.vue");
const ServerPackagesIndex = () =>
    import(/* webpackChunkName: "group-domains-reseller" */ "./components/reseller/ServerPackagesIndex.vue");
const ServerPackagesEditEntityPackage = () =>
    import(
        /* webpackChunkName: "group-domains-reseller" */ "./components/reseller/ServerPackagesEditEntityPackage.vue"
    );

const ResellerPackagesPage = () =>
    import(/* webpackChunkName: "group-domains-reseller" */ "./pages/reseller/ResellerPackagesPage.vue");
const ResellerEditPackagePage = () =>
    import(/* webpackChunkName: "group-domains-reseller" */ "./pages/reseller/ResellerEditPackagePage.vue");

const ResellerImportPage = () =>
    import(/* webpackChunkName: "group-domains-reseller" */ "./pages/reseller/ResellerImportPage.vue");
const ResellerImportWhmPage = () =>
    import(/* webpackChunkName: "group-domains-reseller" */ "./pages/reseller/ResellerImportWhmPage.vue");

const ResellerQuotaPage = () =>
    import(/* webpackChunkName: "group-domains-reseller" */ "./pages/reseller/ResellerQuotaPage.vue");

//entity_events
import EntityEventsIndexPage from "./pages/entity_events/EntityEventsIndexPage.vue";

const routes = [
    { path: "/", redirect: "/servers" },
    {
        path: "/logout",
        component: LogoutPage,
        name: "user.logout",
    },
    {
        path: "/logout-as-user",
        component: LogoutAsUserPage,
        name: "user.logout_as_user",
    },
    {
        path: "/support_sso/token/:company_id/:sso_token",
        component: LoginAsSupportPage,
        name: "user.login_as_support",
        props: (route) => {
            const company_id = Number.parseInt(route.params.company_id, 10);
            if (Number.isNaN(company_id)) {
                return undefined;
            }

            const sso_token = route.params.sso_token;

            return { company_id, sso_token };
        },
    },
    {
        path: "/login/:company_id?",
        component: LoginPage,
        children: [
            {
                path: "setup-2fa",
                component: LoginForce2FA,
                name: "login.force_2fa",
            },
            {
                path: "",
                component: LoginMain,
                name: "login.main",
                props: (route) => {
                    const company_id = Number.parseInt(route.params.company_id, 10);
                    if (Number.isNaN(company_id)) {
                        return undefined;
                    }
                    return { company_id };
                },
            },
        ],
    },
    {
        path: "/invite_account/:invite_data?",
        component: InviteAccountPage,
        children: [
            {
                path: "",
                component: InviteAccountMain,
                name: "invite_account.main",
                props: true,
            },
        ],
    },
    {
        path: "/forgot_password/:company_id?",
        component: ForgotPassPage,
        children: [
            {
                path: "",
                component: ForgotPassMain,
                name: "forgot_password.main",
                props: (route) => {
                    const company_id = Number.parseInt(route.params.company_id, 10);
                    if (Number.isNaN(company_id)) {
                        return undefined;
                    }
                    return { company_id };
                },
            },
        ],
    },
    {
        path: "/reset_password/:company_id/:reset_token",
        component: ResetPassPage,
        children: [
            {
                path: "",
                component: ResetPassMain,
                name: "reset_password.main",
                props: true,
            },
        ],
    },
    {
        path: "/account",
        component: AccountPage,
        children: [
            {
                path: "",
                component: AccountPageIndex,
                children: [
                    {
                        path: "change-password",
                        component: AccountChangePassword,
                        name: "account.change_password",
                    },
                    {
                        path: "2fa",
                        component: Account2FA,
                        name: "account.2fa",
                    },
                    {
                        path: "setup_2fa",
                        component: AccountSetup2FA,
                        name: "account.setup_2fa",
                    },
                    {
                        path: "disable_2fa",
                        component: AccountDisable2FA,
                        name: "account.disable_2fa",
                    },
                    {
                        path: "notifications",
                        component: AccountNotifications,
                        name: "account.notifications",
                    },
                    {
                        path: "api_keys",
                        component: AccountApiKeys,
                        name: "account.api_keys",
                    },
                    {
                        path: "server_accounts",
                        component: AccountServerAccounts,
                        name: "account.server_accounts",
                    },
                    {
                        path: "user_ssh_keys",
                        component: AccountSshKeys,
                        name: "account.user_ssh_keys",
                    },
                    {
                        path: "sub-accounts/:sub_account_id",
                        component: AccountEditSubAccount,
                        name: "account.sub_account",
                        props: (route) => {
                            const sub_account_id = Number.parseInt(route.params.sub_account_id, 10);
                            if (Number.isNaN(sub_account_id)) {
                                return 0;
                            }
                            return { sub_account_id };
                        },
                    },
                    {
                        path: "sub-accounts",
                        component: AccountSubAccounts,
                        name: "account.sub_accounts",
                    },
                    {
                        path: "",
                        component: AccountInformation,
                        name: "account.information",
                    },
                ],
            },
        ],
    },
    {
        path: "/setup",
        component: SetupServersPage,
        children: [
            {
                path: "add-system",
                component: SetupServersAddSystemPage,
                children: [
                    {
                        path: "add-server/:connector_code",
                        component: AddDOServer,
                        name: "servers.addSystem.addServer",
                        props: true,
                    },
                    {
                        path: "",
                        component: AddSystemIndex,
                        name: "servers.addSystem",
                    },
                ],
            },
            {
                path: "add-connector/digitalocean",
                component: AddDOConnectorPage,
                children: [
                    {
                        path: "token",
                        component: AddDOConnectorToken,
                        name: "servers.addConnector.digitalocean.token",
                    },
                    {
                        path: "oauth",
                        component: AddDOConnectorOauth,
                        name: "servers.addConnector.digitalocean.oauth",
                    },
                    {
                        path: "",
                        component: AddDOConnectorDefault,
                        name: "servers.addConnector.digitalocean",
                    },
                ],
            },
            {
                path: "add-connector/digitalocean/oauth_reply",
                component: AddDOConnectorReplyPage,
                children: [
                    {
                        path: "",
                        component: AddDOConnectorOauthReply,
                        name: "servers.addConnector.digitalocean.oauth_reply",
                    },
                ],
            },
            {
                path: "",
                component: SetupServersIndexPage,
                name: "servers.setup",
            },
        ],
    },
    {
        path: "/servers",
        component: ServersPage,
        children: [
            {
                path: "",
                component: ServersIndexPage,
                name: "servers",
            },
            {
                path: "add-server",
                component: ServersAddServerPage,
                name: "servers.addServer",
            },
            {
                path: "add-cluster",
                component: ServersAddClusterPage,
                name: "servers.addCluster",
            },
            {
                path: "test-servers/:test_entity_id/setup",
                name: "servers.test_servers.setup",
                component: ServersSetupPage,
                props: true,
            },
            {
                path: "test-servers/:test_entity_id/check",
                name: "servers.test_servers.check",
                component: ServersCheckPage,
                props: true,
            },
            {
                path: ":entity_id/services",
                name: "servers.services",
                component: ServersServicesPage,
                props: (route) => {
                    const entity_id = Number.parseInt(route.params.entity_id, 10);
                    if (Number.isNaN(entity_id)) {
                        return 0;
                    }
                    return { entity_id };
                },
            },
            {
                path: ":entity_id/firewall",
                name: "servers.firewall",
                component: ServersFirewallPage,
                props: (route) => {
                    const entity_id = Number.parseInt(route.params.entity_id, 10);
                    if (Number.isNaN(entity_id)) {
                        return 0;
                    }
                    return { entity_id };
                },
            },
            {
                path: ":entity_id/email_settings",
                name: "servers.email_settings",
                component: ServersMailPage,
                props: (route) => {
                    const entity_id = Number.parseInt(route.params.entity_id, 10);
                    if (Number.isNaN(entity_id)) {
                        return 0;
                    }
                    return { entity_id };
                },
                redirect: "servers.email_settings.index",
                children: [
                    {
                        path: "",
                        name: "servers.email_settings.index",
                        component: ServersMailSettingsPage,
                    },
                    {
                        path: "ssl",
                        name: "servers.email_settings.ssl",
                        component: ServersMailSslPage,
                        redirect: "servers.email_settings.ssl.index",
                        children: [
                            {
                                path: "",
                                component: ServersMailSslIndexPage,
                                name: "servers.email_settings.ssl.index",
                            },
                            {
                                path: "self-signed",
                                component: ServersMailSslSelfSignedPage,
                                name: "servers.email_settings.ssl.self_signed",
                            },
                            {
                                path: "lets-encrypt",
                                component: ServersMailSslLetsEncryptPage,
                                name: "servers.email_settings.ssl.lets_encrypt",
                            },
                            {
                                path: "csr",
                                component: ServersMailSslGenerateCsrPage,
                                name: "servers.email_settings.ssl.generate_csr",
                            },
                            {
                                path: "certificate",
                                component: ServersMailSslCertificatePage,
                                name: "servers.email_settings.ssl.certificate",
                            },
                        ],
                    },
                ],
            },
            {
                path: ":entity_id/fail2ban_settings",
                name: "servers.fail2ban_settings",
                component: ServersFail2BanSettingsPage,
                props: (route) => {
                    const entity_id = Number.parseInt(route.params.entity_id, 10);
                    if (Number.isNaN(entity_id)) {
                        return 0;
                    }
                    return { entity_id };
                },
            },
        ],
    },
    {
        path: "/reseller",
        component: ResellerIndexPage,
        children: [
            {
                path: "server_packages",
                component: ResellerServerPackagesPage,
                children: [
                    {
                        path: "edit_package/:entity_id/:server_package_id?",
                        component: ServerPackagesEditEntityPackage,
                        name: "reseller.server_packages_edit_entity_package",
                        props: (route) => {
                            const entity_id = Number.parseInt(route.params.entity_id, 10);
                            if (Number.isNaN(entity_id)) {
                                return 0;
                            }
                            const server_package_id = Number.parseInt(route.params.server_package_id, 10);
                            if (Number.isNaN(server_package_id)) {
                                return 0;
                            }
                            return { entity_id, server_package_id };
                        },
                    },
                    {
                        path: "",
                        component: ServerPackagesIndex,
                        name: "reseller.server_packages",
                    },
                ],
            },
            {
                path: "packages",
                component: ResellerPackagesPage,
                name: "reseller.packages",
            },
            {
                path: "package/:package_id",
                component: ResellerEditPackagePage,
                name: "reseller.edit_package",
                props: (route) => {
                    const package_id = Number.parseInt(route.params.package_id, 10);
                    if (Number.isNaN(package_id)) {
                        return 0;
                    }
                    return { package_id };
                },
            },
            {
                path: "accounts",
                component: ResellerAccountsPage,
                children: [
                    {
                        path: "delete",
                        component: ResellerDeleteAccounts,
                        name: "reseller.delete_accounts",
                        props: true,
                    },
                    {
                        path: "edit_account/:ccs_account_id/:account_package_id?",
                        component: ResellerEditAccount,
                        name: "reseller.edit_account",
                        props: (route) => {
                            let ccs_account_id = Number.parseInt(route.params.ccs_account_id, 10);
                            if (Number.isNaN(ccs_account_id)) {
                                ccs_account_id = 0;
                            }

                            let account_package_id = 0;
                            if (route.params.account_package_id) {
                                account_package_id = Number.parseInt(route.params.account_package_id, 10);
                                if (Number.isNaN(account_package_id)) {
                                    account_package_id = 0;
                                }
                            }
                            return { ccs_account_id, account_package_id };
                        },
                    },
                    {
                        path: "",
                        component: ResellerAccountsIndex,
                        name: "reseller.accounts",
                    },
                ],
            },
            {
                path: "import",
                component: ResellerImportPage,
                name: "reseller.import",
            },
            {
                path: "quota",
                component: ResellerQuotaPage,
                name: "reseller.quta",
            },
            {
                path: "import_whm",
                component: ResellerImportWhmPage,
                name: "reseller.import_whm",
            },
            {
                path: "",
                component: ResellerInfoPage,
                name: "reseller.info_page",
            },
        ],
    },
    {
        path: "/account_system_restart",
        component: AccountSystemRestart,
        name: "account_system_restart",
    },
    {
        path: "/domains",
        component: DomainsIndexPage,
        name: "domains.index",
    },
    {
        path: "/domains/create",
        component: DomainsManageCreatePage,
        name: "domains.manage.create",
    },
    {
        path: "/domains_import_cpanel",
        component: DomainsImportCpanelPage,
        name: "domains.import_cpanel",
    },
    {
        path: "/domains_import_clustercs",
        component: DomainsImportClusterCSPage,
        name: "domains.import_clustercs",
    },
    {
        path: "/domains/:domain_id",
        component: DomainsPage,
        // name: "domains.manage",
        // redirect: "domains.manage.index",
        children: [
            {
                path: "",
                component: DomainsManagePage,
                name: "domains.manage",
                redirect: "domains.manage.index",
                children: [
                    {
                        path: "",
                        component: DomainsManageIndexPage,
                        name: "domains.manage.index",
                        props: true,
                    },
                    {
                        path: "edit",
                        component: DomainsManageEditPage,
                        name: "domains.manage.edit",
                    },
                    {
                        path: "edit_env",
                        component: DomainsManageEditEnvPage,
                        name: "domains.manage.edit_env",
                    },
                    {
                        path: "ssh-keys",
                        component: DomainsSSHKeysPage,
                        name: "domains.sshkeys",
                    },
                ]
            },
            {
                path: "manage-environments",
                component: DomainsEnvironmentsManagePage,
                name: "domains.environments.manage",
            },
            {
                path: "environments",
                component: EnvironmentsPage,
                name: "domains.environments",
                redirect: { name: "domains.environments.migrate" },
                children: [
                    {
                        path: "git",
                        component: DomainsEnvironmentsGitBranchSettingsPage,
                        name: "domains.environments.git_branch_settings",
                    },
                    {
                        path: "installers",
                        component: DomainsEnvironmentsInstallersPage,
                        name: "domains.environments.installers",
                    },
                    {
                        path: "installers/:installer",
                        component: DomainsEnvironmentsInstallerPage,
                        name: "domains.environments.installer",
                    },
                    {
                        path: "migrate",
                        component: DomainsEnvironmentsMigrate,
                        name: "domains.environments.migrate",
                    },
                    {
                        path: "git-ops",
                        component: DomainsEnvironmentsGitOps,
                        name: "domains.environments.gitOps",
                    },
                    {
                        path: "settings",
                        component: DomainsEnvironmentsSettings,
                        name: "domains.environments.settings",
                    },
                    {
                        path: "tracked_items",
                        component: DomainsEnvironmentsTrackedItems,
                        name: "domains.environments.tracked_items",
                    },
                    {
                        path: "push",
                        component: DomainsEnvironmentsPush,
                        name: "domains.environments.push",
                    },
                ],
            },
            {
                path: "cronjobs",
                name: "domains.cronjobs",
                component: DomainsCronjobsPage,
                redirect: "domains.cronjobs.index",
                children: [
                    {
                        path: "",
                        component: DomainsCronjobsIndexPage,
                        name: "domains.cronjobs.index",
                    },
                    {
                        path: "create",
                        component: DomainsCronjobsCreatePage,
                        name: "domains.cronjobs.create",
                    },
                    {
                        path: 'manage/:cronjob_id',
                        component: DomainsCronjobsManagePage,
                        name: "domains.cronjobs.manage",
                        props: (route) => {
                            let cronjob_id = Number.parseInt(route.params.cronjob_id, 10);
                            if (Number.isNaN(cronjob_id)) {
                                cronjob_id = 0;
                            }
                            return { cronjob_id };
                        },
                    },
                    // {
                    //     path: "manage",
                    //     component: CronjobsManagePage,
                    //     name: "domains.cronjobs.manage",
                    // },
                ],
            },
            {
                path: "mails",
                name: "domains.mails",
                component: DomainsMailsPage,
                redirect: "domains.mails.index",
                children: [
                    {
                        path: "",
                        component: DomainsMailsIndexPage,
                        name: "domains.mails.index",
                    },
                    {
                        path: "create",
                        component: DomainsMailsCreatePage,
                        name: "domains.mails.create",
                    },
                    {
                        path: ":account_id/manage",
                        component: DomainsMailsManagePage,
                        name: "domains.mails.manage",
                    },
                ],
            },
            {
                path: "dns",
                name: "domains.dns",
                component: DomainsDnsPage,
                redirect: "domains.dns.index",
                children: [
                    {
                        path: "",
                        component: DomainsDnsIndexPage,
                        name: "domains.dns.index",
                    },
                ],
            },
            {
                path: "backups/manage",
                name: "domains.backups",
                component: DomainsBackupsPage,
                redirect: "domains.backups.index",
                children: [
                    {
                        path: "",
                        component: DomainsBackupsIndexPage,
                        name: "domains.backups.index",
                    },
                    {
                        path: "create/repo",
                        component: DomainsBackupCreateRepoPage,
                        name: "domains.backups.repo.create",
                    },
                    {
                        path: "edit-repo/:repo_id",
                        component: DomainsBackupEditRepoPage,
                        name: "domains.backups.repo.edit",
                    },
                    {
                        path: "create/job",
                        component: DomainsBackupCreateJobPage,
                        name: "domains.backups.job.create",
                    },
                    {
                        path: "edit-job/:backup_job_id",
                        component: DomainsBackupEditJobPage,
                        name: "domains.backups.job.edit",
                    },
                ],
            },
            {
                path: "ssl",
                name: "domains.ssl",
                component: DomainsSslPage,
                redirect: "domains.ssl.index",
                children: [
                    {
                        path: "",
                        component: DomainsSslIndexPage,
                        name: "domains.ssl.index",
                    },
                    {
                        path: "self-signed",
                        component: DomainsSslSelfSignedPage,
                        name: "domains.ssl.self_signed",
                    },
                    {
                        path: "lets-encrypt",
                        component: DomainsSslLetsEncryptPage,
                        name: "domains.ssl.lets_encrypt",
                    },
                    {
                        path: "csr",
                        component: DomainsSslGenerateCsrPage,
                        name: "domains.ssl.generate_csr",
                    },
                    {
                        path: "certificate",
                        component: DomainsSslCertificatePage,
                        name: "domains.ssl.certificate",
                    },
                ],
            },
            {
                path: "logs",
                name: "domains.logs",
                component: DomainsLogsPage,
            },
            // {
            //     path: "ftp",
            //     component: DomainsFtpPage,
            //     name: "domains.ftp",
            //     children: [
            //         {
            //             path: "",
            //             component: DomainsFtpIndexPage,
            //             name: "domains.ftp.index",
            //         },
            //     ],
            // },
        ],
    },
    {
        path: "/entity_events/:entity_id",
        component: EntityEventsIndexPage,
        name: "entity_events.index",
    },
];

export default new VueRouter({
    base: "/ui/",
    mode: "history",
    routes,
});
